const COUNTRY_CODE_TO_PEXELS_LOCALE: Record<string, string> = {
  KR: 'ko-KR',
  US: 'en-US',
  JP: 'ja-JP',
  ID: 'id-ID',
  TH: 'th-TH',
  PH: 'fil-PH',
  VN: 'vi-VN',
  MY: 'ms-MY',
  UZ: 'uz-UZ',
  FR: 'fr-FR',
  KH: 'km-KH',
  RU: 'ru-RU',
  CN: 'zh-CN',
  TW: 'zh-TW',
  ES: 'es-ES',
  PT: 'pt-PT',
  DE: 'de-DE',
  IT: 'it-IT',
  TR: 'tr-TR',
};

export const getPexelsLocale = (countryCode: string): string => {
  return COUNTRY_CODE_TO_PEXELS_LOCALE[countryCode?.toUpperCase()] || 'en-US';
};
